import * as queries from "./query";

import ProviderService from "@services/Provider";

export const providerService = new ProviderService({ queries });
